export default __webpack_public_path__ + "static/contactCover-fdaeeb58e9296705c1bbbcaa669299f9.png";